import { FormControl } from '@chakra-ui/react'
import styled from '@emotion/styled'
import calendar from '../../../components/atoms/Icon/svg/calendar.svg'

export const FormControlCustom = styled(FormControl)`
    textarea {
        border: 1px solid #888891;
    }
    input[type='date']::-webkit-calendar-picker-indicator {
        width: 20px;
        height: 20px;
        color: transparent;
        background: transparent;
        background-image: url('${calendar}');
    }
`
